import React from "react";
import "../assets/css/component-alert-notification-info.css";
import { MdInfo, MdClose } from "react-icons/md";

export default function AlertNotificationInfo({ message, setCopyText }) {
  return (
    <>
      <div className="my__component__alert__notification__info animate__animated animate__fadeInLeftBig animate__faster">
        <div className="my__component__alert__notification__info__icon">
          <MdInfo className="my__component__alert__notification__icon" />
        </div>
        <div className="my__component__alert__notification__info__title">
          {message}
        </div>
        <div className="my__component__alert__notification__info__close">
          <MdClose
            onClick={() => setCopyText(false)}
            className="my__component__alert__notification__close"
          />
        </div>
      </div>
    </>
  );
}
